import CreateChannel from './CreateChannel'

export default CreateChannel
